export const cil3d = ["24 24","<path d='M20.798 6.064l-8.032-4.637c-0.215-0.126-0.474-0.2-0.75-0.2s-0.535 0.074-0.757 0.204l0.007-0.004-8.032 4.637c-0.451 0.265-0.749 0.747-0.75 1.299v9.275c0.001 0.552 0.299 1.034 0.743 1.295l0.007 0.004 8.032 4.637c0.215 0.126 0.474 0.2 0.75 0.2s0.535-0.074 0.757-0.204l-0.007 0.004 8.032-4.637c0.451-0.265 0.749-0.747 0.75-1.299v-9.275c-0.001-0.552-0.299-1.034-0.743-1.295l-0.007-0.004zM20.048 7.363v8.315l-7.282-4.116v-8.403zM3.984 7.363l7.282-4.204v8.4l-7.282 4.116zM12.016 21.275l-7.367-4.253 7.364-4.162 7.367 4.164z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-3d.js
// module id = null
// module chunks = 